module.exports = __webpack_public_path__ + "asset/backImg02_9wNHo6oM.png";